export default {
  article_breadcrumb_home: 'Home',
  article_breadcrumb_current: 'USFans Spreadsheet Guide',
  article_category: 'Guides',
  article_reading_time: '8 min read',
  article_updated: 'Updated',
  article_title: 'USFans Spreadsheet Guide: What It Is & How to Use It',
  article_lead:
    'A USFans Spreadsheet is a simple, structured way to organize and research product, seller and resource information. This guide explains what it is, why people use it, and how to get the most out of it — step by step.',

  article_h2_1: 'What Is a USFans Spreadsheet?',
  article_p_1:
    'A USFans Spreadsheet is a structured way to organize and research product, seller and resource information in one place. Instead of jumping between scattered pages, you can use organized spreadsheet resources to discover information, compare options and continue your research more efficiently.',
  article_p_2:
    'Think of it as a research map: it groups related items together so you can quickly see what is available, compare details and decide where to look next. The spreadsheet itself is a way of organizing information, while the actual products and current prices live on the main website.',

  article_h2_2: 'Why Use a USFans Spreadsheet?',
  article_p_3:
    'People use spreadsheets to save time and stay organized. When you are researching many products or sellers at once, a structured layout helps you compare options without losing track of what you have already checked.',
  article_li_1: 'Organize many products and categories in one view',
  article_li_2: 'Compare products, sellers and resources side by side',
  article_li_3: 'Keep your research notes in one consistent place',
  article_li_4: 'Move from research to the main website more quickly',

  article_h2_3: 'How to Use a USFans Spreadsheet (Step by Step)',
  article_step_1_title: 'Pick a category',
  article_step_1_desc: 'Start with a category such as Shoes, T-Shirts or Bags to narrow your research.',
  article_step_2_title: 'Compare the options',
  article_step_2_desc: 'Look at the different items and note the details that matter to you.',
  article_step_3_title: 'Verify information',
  article_step_3_desc: 'Always check links, sellers and product details independently before deciding.',
  article_step_4_title: 'Continue to the main website',
  article_step_4_desc: 'When you are ready, follow the links to the main website to explore further.',

  article_h2_4: 'A Quick Comparison',
  article_compare_col_feature: 'Feature',
  article_compare_col_a: 'Spreadsheet Research',
  article_compare_col_b: 'Seller Research',
  article_cr1_label: 'Information depth',
  article_cr1_a: 'High',
  article_cr1_b: 'Medium',
  article_cr2_label: 'Ease of use',
  article_cr2_a: 'Easy',
  article_cr2_b: 'Moderate',
  article_cr3_label: 'Best for',
  article_cr3_a: 'Comparing products',
  article_cr3_b: 'Verifying sellers',

  article_h2_5: 'Safety Tips to Keep in Mind',
  article_p_4:
    'Before using any spreadsheet, product link or seller information, take time to verify the source. A few simple habits can help you avoid common mistakes.',
  article_safe_1: 'Verify links before clicking or buying',
  article_safe_2: 'Never share passwords or sensitive personal information',
  article_safe_3: 'Be cautious with unofficial pages that copy a real brand',
  article_safe_4: 'Double-check prices, shipping and stock on the main website',

  article_h2_6: 'Frequently Asked Questions',
  article_faq_q1: 'Is a USFans Spreadsheet free to use?',
  article_faq_a1:
    'Using an organized spreadsheet as a research aid is free. Actual product prices, shipping and availability are shown on the main website.',
  article_faq_q2: 'Where do I find the latest products?',
  article_faq_a2:
    'The most current products and prices are on the main website. Use the categories here to jump directly to the section you need.',
  article_faq_q3: 'Do I need an account?',
  article_faq_a3:
    'For browsing resources here, no account is needed. The main website may have its own requirements.',

  article_cta_title: 'Continue Your Research',
  article_cta_body:
    'Explore organized categories and resources, then continue to the main website when you are ready.',
  article_cta_primary: 'Explore USFans Spreadsheet',
  article_cta_secondary: 'Back to Homepage',
  article_not_found: 'Article Not Found',
  article_not_found_desc:
    'The article you are looking for could not be found. Browse our guides from the homepage instead.',
  article_related: 'Related Guides',

  article_disclaimer:
    'Disclaimer: USFansLink.boats is an independent informational resource and is not the official USFans website. Always independently verify sellers, links, products, prices, shipping information and transaction details before making any decision.',
};